import React, { Component, Fragment } from 'react';
import { Label, Input, FormText } from 'reactstrap';

class UploadImage extends Component {
  render() {
    const {
      idUploadInput,
      isImageLoading,
      labelClass,
      inputClass,
      helpText,
      onChange,
      name,
      label,
      value,
      setFiles,
      ...props
    } = this.props;
    return (
      <Fragment>
        <Label
          for={idUploadInput}
          className={labelClass + (isImageLoading ? ' spinner' : '')}>
          {isImageLoading ? (
            <div className="b-spinner__loader" />
          ) : (
            <div>{label}</div>
          )}
        </Label>
        <Input
          type="file"
          className={inputClass}
          name={name}
          id={idUploadInput}
          onChange={setFiles}
          {...props}
        />
        {helpText && (
          <FormText color="muted-grey" className="form-text__big">
            {helpText}
          </FormText>
        )}
      </Fragment>
    );
  }
}

export default UploadImage;



// WEBPACK FOOTER //
// ./src/components/UploadImage/UploadImage.js